<template>
    <div class="theme-navigator">
        <div
            v-for="theme in availableThemes"
            :key="theme.id"
            :class="['theme-tab', { active: modelValue === theme.id }]"
            @click="handleTabClick(theme.id)"
        >
            <span v-if="theme.id !== 'all'" class="status-dot" :class="theme.status"></span>
            <span v-else style="margin-right: 4px">📊</span>

            <span class="theme-name">{{ $t(`theme-name.${theme.id}`) }}</span>

            <div v-if="modelValue === theme.id" class="active-bar"></div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { getAvailableThemes } from '@/themes'

const props = defineProps(['modelValue'])
const emit = defineEmits(['update:modelValue', 'meteor-click'])

const store = useStore()

// 主題定義與可用性判斷集中在 @/themes，Content.vue 與 DesktopViewport 共用同一份
const availableThemes = computed(() => getAvailableThemes(store.state.selectedStation))

const handleTabClick = (id) => {
    if (id === 'meteor') {
        emit('meteor-click')
    } else {
        emit('update:modelValue', id)
    }
}
</script>

<style lang="scss" scoped>
.theme-navigator {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin: 5px 0 10px 0;
    width: 100%;
}

.theme-tab {
    position: relative;
    padding: 8px 20px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    color: #4a5568;
    border: 1px solid rgba(138, 171, 161, 0.3);

    &:hover {
        background: rgba(255, 255, 255, 1);
        transform: translateY(-2px);
    }

    &.active {
        background: #005088;
        color: white;
        box-shadow: 0 4px 12px rgba(0, 80, 136, 0.2);
        .theme-name {
            font-weight: bold;
        }
    }
}

.status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    &.online {
        background: #22c55e;
        box-shadow: 0 0 4px #22c55e;
    }
    &.offline {
        background: #ef4444;
        box-shadow: 0 0 4px #ef4444;
    }
}

.active-bar {
    position: absolute;
    bottom: 0;
    left: 20%;
    width: 60%;
    height: 3px;
    background: #11caa0;
    border-radius: 10px;
}
</style>
